import React from 'react'
import Footer from '../components/Footer';
import Main from '../components/Main'
import Navigation from "../components/Navigation";

function Home() {
  return (
    <>
        <Navigation />
        <Main />
        <Footer />
    </>
  )
}

export default Home